import { Input } from '@aus-platform/design-system';
import type { ReactNode } from 'react';

type TableRowSelectColumnProps = {
  headerText?: ReactNode;
  showCheckboxIndex?: boolean;
};

export const tableRowSelectColumn = ({
  headerText = undefined,
  showCheckboxIndex = false,
}: TableRowSelectColumnProps) => ({
  id: 'selection',
  maxSize: 1,
  style: {},
  header: ({ table }) => {
    if (headerText) {
      return <div className="header-text">{headerText}</div>;
    }
    const hasRows = table.getRowModel().rows.length > 0;
    return (
      <Input.CheckBox
        {...{
          checked: table.getIsAllPageRowsSelected(),
          indeterminate: table.getIsSomePageRowsSelected(),
          onChange: table.getToggleAllPageRowsSelectedHandler(),
          disabled: !hasRows,
        }}
      />
    );
  },
  cell: ({ row }) => {
    return showCheckboxIndex ? (
      <div className="table-checkbox">
        <Input.CheckBox
          {...{
            checked: row.getIsSelected(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
          }}
        />
        {row.index + 1}.
      </div>
    ) : (
      <Input.CheckBox
        {...{
          checked: row.getIsSelected(),
          indeterminate: row.getIsSomeSelected(),
          onChange: row.getToggleSelectedHandler(),
        }}
      />
    );
  },
});
